import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image/withIEPolyfill";

import Layout from "../components/layout/layout";
import SEO from "../components/seo/seo";
import styled from "styled-components";
import Container, { Row, Half, Quarter, ThreeQuarter } from "../components/layout/container";
import BlogItems from "../components/blog/blog-items"



const Blog = ({ data }) => {
  return (
    <Layout>
        <SEO title="" description="" />
        <Container>
            <Row>
                <BlogItems items={data} />
            </Row>
            {/* <Row>
                <PlanVisit />
            </Row> */}
        </Container>
    </Layout>
  );
};

export default Blog;

export const query = graphql`
    query {
        allContentfulWhatsOn(sort: { fields: publishedDate, order: DESC }) {
            edges {
                node {
                    title
                    id
                    slug
                    category
                    publishedDate(formatString: "Do MMMM, YYYY")
                    featuredImage {
                        gatsbyImageData(
                            width: 250
                            placeholder: BLURRED
                        )
                    }
                    standfirst {
                        childMarkdownRemark {
                            excerpt(pruneLength: 150)
                        }
                    }
                }
            }
        }
    }
    
`